import React from 'react';
import Icon from '../../../components/AppIcon';

const OrderConfirmation = ({ orderNumber, email, orderDate }) => {
  return (
    <div className="bg-card rounded-lg shadow-elevation-2 p-6 mb-6">
      <div className="text-center mb-6">
        <div className="w-16 h-16 bg-success rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="CheckCircle" size={32} color="white" />
        </div>
        <h1 className="text-2xl font-bold text-foreground mb-2">Order Confirmed!</h1>
        <p className="text-muted-foreground">
          Thank you for your purchase. Your tickets are ready!
        </p>
      </div>

      <div className="bg-muted rounded-lg p-4 space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-sm font-medium text-foreground">Order Number:</span>
          <span className="text-sm font-mono text-primary">{orderNumber}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm font-medium text-foreground">Order Date:</span>
          <span className="text-sm text-foreground">{orderDate}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm font-medium text-foreground">Confirmation Email:</span>
          <span className="text-sm text-foreground">{email}</span>
        </div>
      </div>

      <div className="mt-4 p-3 bg-accent/10 border border-accent/20 rounded-lg">
        <div className="flex items-start space-x-2">
          <Icon name="Mail" size={16} className="text-accent mt-0.5" />
          <div className="text-sm">
            <p className="text-foreground font-medium">Email Confirmation Sent</p>
            <p className="text-muted-foreground">
              Check your inbox for order details and tickets
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;